<template>
  <div>
    <slot
      name="content"
      :item="{
        interval: interval.toString(),
        numPresentUsers: numPresentUsers,
        numTotalUsers: numTotalUsers,
        usersRate: usersRate,
        usersRatePercent: (usersRate * 100).toFixed(2) + '%',
        numBookedDesks: numBookedDesks,
        numTotalDesks: numTotalDesks,
        desksRate: desksRate,
        desksRatePercent: (desksRate * 100).toFixed(2) + '%',
        numRooms: numRooms,
      }"
    >
    </slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CentersOccupancyRate",
  props: {
    centers: null,
    interval: null,
  },
  computed: {
    ...mapGetters("userModule", { usersByCenter: "getUsersByCenter" }),
    ...mapGetters("bookingModule", {
      bookings: "getBookings",
      activeBookingsByCenterOnInterval: "getActiveBookingsByCenterOnInterval",
      roomBookingsByTimeSlots: "getRoomBookingsByTimeSlots",
    }),
    ...mapGetters("roomModule", {
      availableRoomsByCenter: "getAvailableRoomsByCenter",
    }),
    ...mapGetters("deskModule", {
      availableDesksByRoom: "getAvailableDesksByRoom",
    }),

    users() {
      const users = [];
      for (const center of this.centers) users.push(this.usersByCenter(center));
      return users.flat();
    },
    numTotalUsers() {
      return this.users.length;
    },
    activeBookings() {
      const bookings = [];
      for (const center of this.centers)
        bookings.push(
          this.activeBookingsByCenterOnInterval(center, this.interval)
        );
      return bookings.flat();
    },
    presentUsers() {
      const bookings = this.activeBookings.filter((x) =>
        this.users.includes(x.user)
      );
      const uniqueUsers = new Set();
      for (const booking of bookings) uniqueUsers.add(booking.user.id);
      return uniqueUsers;
    },
    numPresentUsers() {
      return this.presentUsers.size;
    },
    usersRate() {
      return this.numPresentUsers / this.numTotalUsers;
    },
    rooms() {
      const rooms = [];
      for (const center of this.centers)
        rooms.push(this.availableRoomsByCenter(center));
      return rooms.flat();
    },
    numTotalDesks() {
      let numDesks = 0;
      for (const room of this.rooms)
        numDesks += (this.availableDesksByRoom(room).length || 1) * 18;
      return numDesks;
    },
    numBookedDesks() {
      if (!this.bookings) return 0;
      let numDesks = 0;
      let date = this.interval.start;
      while (date < this.interval.end) {
        for (const room of this.rooms) {
          const res = this.roomBookingsByTimeSlots(room, date);
          if (!res) continue;
          for (const slot of res.slots) {
            if (slot.whole)
              numDesks += this.availableDesksByRoom(room).length || 1;
            else if (slot.any) numDesks += slot.desks.size;
          }
        }
        date = date.plus({ days: 1 });
      }
      return numDesks;
    },
    desksRate() {
      if (this.numTotalDesks === 0) return 1;
      else return this.numBookedDesks / this.numTotalDesks;
    },
    numRooms() {
      return this.rooms.length;
    },
  },
};
</script>
